export interface IPaginationMeta {
  totalResults?: number;
  curPage?: number;
  totalPages?: number;
  perPage?: number;
}
